export class EmailAttachmentVendorSelectorResultDto {
    communityVendorId: number;
    vendorName: string;

    isActive: boolean;
    approved: boolean;
}
